import useSWR from 'swr';
import { fetchAgentGeneratedFileSaveOptions } from './agentPlatformApi';
import type {
  CommendaAiGeneratedFileRef,
  CommendaAiGeneratedFileSaveOptions,
} from './types';

export function useGeneratedFileSaveOptions(
  ref: CommendaAiGeneratedFileRef,
  entityId: number | undefined,
  documentSubType: string | undefined
): {
  saveOptions: CommendaAiGeneratedFileSaveOptions | undefined;
  isLoading: boolean;
  isRefreshing: boolean;
  error: Error | undefined;
  refresh: () => Promise<unknown>;
} {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    entityId === undefined
      ? null
      : ([
          'commenda-ai/generated-file-save-options',
          ref.conversationId,
          ref.messageId,
          ref.fileUrl,
          entityId,
          documentSubType,
        ] as const),
    ([, , , , keyEntityId, keyDocumentSubType]) =>
      fetchAgentGeneratedFileSaveOptions(ref, keyEntityId, keyDocumentSubType),
    { revalidateOnFocus: false, keepPreviousData: true }
  );

  return {
    saveOptions: data,
    isLoading: entityId !== undefined && isLoading,
    isRefreshing: isValidating,
    error,
    refresh: mutate,
  };
}
